module.exports = __webpack_public_path__ + "img/logo_white.316fc2b5.png";